import { Ability } from '@casl/ability';

function detectSubjectType(item: any) {
	if (!item || typeof item === 'string') {
		return item;
	}
	return item.__type;
}

const ability = new Ability([], { detectSubjectType });

export default ability;
